module.exports = __webpack_public_path__ + "static/media/avatar-5.1a811883.svg";